export const NETWORK_TOOLTIP = 'NETWORK_PROVIDER';
export const TECHNOLOGY_TOOLTIP = 'TECHNOLOGY';
export const LEGEND_TOOLTIP = 'LEGEND';



// WEBPACK FOOTER //
// ./src/enum/tooltips.enum.js